(ns manatee.auth.subs
  "Subscriptions for login form."
  (:require
   [manatee.auth.app-db :as auth-db]
   [re-frame.core :as rf]))

;; Login Form Payload

(rf/reg-sub
 ::login-payload
 (fn login-payload
   [db _]
   (auth-db/get-login-payload db)))

;; Login Form Fields

(rf/reg-sub
 ::email-dirty?
 (fn email-dirty?
   [db _]
   (auth-db/email-dirty? db)))

(rf/reg-sub
 ::password-dirty?
 (fn password-dirty?
   [db _]
   (auth-db/password-dirty? db)))
